import Swal, { SweetAlertOptions } from "sweetalert2";
import { URL_API } from "../config/default";
import { useState } from "react";
import Spinner from "../components/UI/Spinner/Spinner";
import { Card, CardContent } from "../components/UI/Card";

const RecuperarContraseña = () => {

  const [loading, setLoading] = useState(false);
  const [auth, setAuth] = useState<any>({
    firstname: "",
    lastname: "",
    phone: "",
    address: "",
    timezone: "America/Buenos_Aires",
    lang: "ESP",
    currency: "ARS",
    email: "",
    password: "",
  });

  const submit = async () => {
    setLoading(true);
    const formdata = new FormData();
    formdata.append("email", auth.email);
    formdata.append("password", auth.password);

    const requestOptions = {
      method: "POST",
      body: formdata,
    };

    fetch(`${URL_API}/auth/recovery-password`, requestOptions)
      .then(async (response) => {
        const result = await response.json();
        localStorage.removeItem("token");
        localStorage.setItem("token", result.token);
        const Toast = Swal.mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.onmouseenter = Swal.stopTimer;
            toast.onmouseleave = Swal.resumeTimer;
          },
        } as SweetAlertOptions);
        Toast.fire({
          icon: "success",
          title: "Ingreso exitoso!",
        });
        setLoading(false);
        return (window.location.href = "/");
      })
      .then((result) => console.log(result))
      .catch((error) => console.error(error));
  };

  return (
    <div className="container mt-4 max-w-lg mx-auto">
      <Card className="shadow-lg">
        <h1 className="text-center text-2xl sm:text-3xl font-bold text-gray-900 mb-2">Cambia tu contraseña</h1>

        <div className="py-6 px-3 text-center font-bold text-base text-gray-600">
          Puedes cambiar tu contraseña en un plazo de 24hrs desde que se envio el
          mail
        </div>
        <CardContent className="p-6 space-y-4">
          <div className="w-full  mb-4 px-[30px]">
            <div>
              <div className="py-2">
                <div className="mb-4">
                  <div>

                    <input
                      name="email"
                      type="email"
                      placeholder="Email"
                      className="border border-gray-300 text-gray-900 sm:text-sm mb-3 rounded-xl focus:ring-primary-600
                       focus:border-primary-600 block w-full p-2.5 placeholder:text-gray-500 placeholder:font-bold"
                      onChange={(e) =>
                        setAuth({ ...auth, email: e.target.value })
                      }
                    />

                  </div>
                </div>

                <label className="cursor-pointer btn bg-[#8B9456] text-white font-bold w-full block text-center py-3 rounded-xl text-xl flex justify-center items-center">
                  {loading ? <Spinner /> : <span>Continuar</span>}
                  <button className="hidden" onClick={() => submit()}></button>
                </label>
              </div>
            </div>
          </div>
        </CardContent>

      </Card>
    </div>
  )
}

export default RecuperarContraseña